module.exports = __webpack_public_path__ + "images/7c982a90f412c58e3d486e5c14270c0c-IMG_6375.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_6375.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_6375.jpg
// module chunks = 0